import { Row, Title, useTranslation } from '@packages/utils';
import { TGeneralElcDocsSectionProps } from './GeneralElcDocsSection.types';
import ResourceItem from '../components/ResourceItem';

const GeneralElcDocsSection = ({
  elcId,
  data,
  isResourceEditable,
}: TGeneralElcDocsSectionProps) => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.admin-portal.elcs.detail.resources-tab.sections',
  });
  return (
    <div data-cy="general_elc_docs_section">
      <Title level={4} className="mt-6 mb-3">
        {t('GENERAL_ELC_DOCS')}
      </Title>
      <Row gutter={[16, 16]}>
        {data.map(item => (
          <ResourceItem
            key={item.resourceId}
            data={item}
            elcId={elcId}
            isResourceEditable={isResourceEditable}
          />
        ))}
      </Row>
    </div>
  );
};

export default GeneralElcDocsSection;
